import Swal from 'sweetalert2';

const CustomSwal = Swal.mixin({
  allowOutsideClick: false,
  // Add any other global defaults here
});

export default CustomSwal;